// Copyright (C) Microsoft Corporation. All rights reserved.

import { InitializeCarouselModalEvents } from './VideoCarouselModal';

(<any>window).InitializeCarouselModal = InitializeCarouselModalEvents;
